import { Grid } from "@mui/material";
import { GridDirection, GridProps } from "@mui/material/Grid/Grid";
import { observer } from "mobx-react";
import React, { FunctionComponent } from "react";
import {
    ChatPersona,
    IAugmentedChatRecord,
    IChatRecord,
} from "../AcxChatViewer";
import { ChatViewModel } from "../ViewModel/ChatViewModel";
import ChatMessage from "./ChatMessage";
import { useTheme } from "@mui/material";

interface OwnProps {
    records: IAugmentedChatRecord[];
    viewModel?: ChatViewModel;
    disableClip?: boolean;
}

type Props = OwnProps;

const ChatMessageList: FunctionComponent<Props> = observer((props) => {
    const theme = useTheme();
    return (
        <div
            style={{
                height: "100%",
                backgroundColor: theme.palette.white.main,
                paddingTop: 8,
                paddingBottom: 8,
                paddingLeft: 32,
                paddingRight: 32,
            }}
        >
            {props.records.map((rec, index) => {
                const layoutProps = chatPersonaToLayoutProps(rec);
                const key =
                    rec.clipId && rec.startIndex === index
                        ? `${rec.clipId} ${index}`
                        : `${rec.text}|${rec.timestamp} ${index}`;
                return (
                    <Grid
                        key={key}
                        container
                        sx={{ marginBottom: 3 }}
                        direction={layoutProps.direction}
                        ref={(instance) => {
                            if (rec.startIndex === index) {
                                props.viewModel?.setClipMessageRef(
                                    key,
                                    instance,
                                );
                            }
                        }}
                    >
                        <Grid
                            item
                            container
                            xs={12}
                            alignItems={"flex-end"}
                            wrap={"nowrap"}
                            spacing={1}
                            justifyContent={layoutProps.justify}
                            direction={layoutProps.direction}
                        >
                            <ChatMessage
                                record={rec}
                                index={index}
                                viewModel={props.viewModel}
                                disableClip={props.disableClip}
                            />
                            <Grid item xs={6} />
                        </Grid>
                    </Grid>
                );
            })}
        </div>
    );
});

function chatPersonaToLayoutProps(chatRecord: IChatRecord) {
    if (chatRecord.from === ChatPersona.Agent) {
        return {
            justify: "flex-start" as GridProps["justifyContent"],
            direction: "row" as GridDirection,
        };
    } else {
        return {
            justify: "flex-start" as GridProps["justifyContent"],
            direction: "row-reverse" as GridDirection,
        };
    }
}

export default ChatMessageList;
